export const CLIENTS = "CLIENTS"
export const CLIENTS_SUCCESS = "CLIENTS_SUCCESS"
export const CLIENTS_FAILED = "CLIENTS_FAILED"
export const SINGLE_CLIENTS = "SINGLE_CLIENTS"
export const SINGLE_CLIENTS_SUCCESS = "SINGLE_CLIENTS_SUCCESS"
export const SINGLE_CLIENTS_FAILED = "SINGLE_CLIENTS_FAILED"
export const ADD_CLIENTS = "ADD_CLIENTS"
export const ADD_CLIENTS_SUCCESS = "ADD_CLIENTS_SUCCESS"
export const ADD_CLIENTS_FAILED = "ADD_CLIENTS_FAILED"
export const UPDATE_CLIENTS = "UPDATE_CLIENTS"
export const UPDATE_CLIENTS_SUCCESS = "UPDATE_CLIENTS_SUCCESS"
export const UPDATE_CLIENTS_FAILED = "UPDATE_CLIENTS_FAILED"
export const SEARCHEDCLIENT = "SEARCHEDCLIENT"
export const SEARCHEDCLIENT_SUCCESS = "SEARCHEDCLIENT_SUCCESS"
export const SEARCHEDCLIENT_FAILED = "SEARCHEDCLIENT_FAILED"